import classnames from 'classnames';
import { type HTMLAttributes } from 'react';

import styles from './scrollable-container.module.scss';

export const ScrollableContainer = ({ children, className }: HTMLAttributes<HTMLDivElement>) => (
  <div className={classnames(styles['scrollable-container'], className)}>{children}</div>
);
